import styled from 'styled-components'

const Wrapper = styled.section`
  .slider {
    position: relative;
    width: 200px;
  }
  
  .slider__track,
  .slider__range {
    border-radius: 3px;
    height: 5px;
    position: absolute;
  }
  
  .slider__track {
    background-color: #ced4da;
    width: 100%;
    z-index: 1;
  }
  
  .slider__range {
    background-color: var(--primary-300);
    z-index: 2;
  }
  
  /* Removing the default appearance */
  .thumb,
  .thumb::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
  }
  
  .thumb {
    pointer-events: none;
    position: absolute;
    height: 0;
    width: 200px;
    outline: none;
    margin-top: 2px;
  }
  
  .thumb--zindex-3 {
    z-index: 3;
  }
  
  .thumb--zindex-4 {
    z-index: 4;
  }

  .thumb--zindex-5 {
    z-index: 5;
  }  
  
  /* For Chrome browsers */
  .thumb::-webkit-slider-thumb {
    background-color: #f1f5f7;
    border: 1px solid lightgrey;
    border-radius: 50%;
    box-shadow: 0 0 1px 1px #ced4da;
    cursor: pointer;
    height: 18px;
    width: 18px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }
  
  /* For Firefox browsers */
  .thumb::-moz-range-thumb {
    background-color: #f1f5f7;
    border: 1px solid lightgrey;
    border-radius: 50%;
    box-shadow: 0 0 1px 1px #ced4da;
    cursor: pointer;
    height: 21px;
    width: 21px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }

  .slider__left-value,
  .slider__right-value {
    color: var(--grey-500);
    font-size: 14px;
    margin-top: 16px;
    position: absolute;
  }

  .slider__left-value {
    left: -3px;
  }

  .slider__right-value {
    right: -4px;
  }
`

export default Wrapper